import C from '../../../constants';

// show or hide navbar
export const setNavbarVisibility = (newState) => ({
    type: C.NAVBAR_SHOW,
    payload: newState
});

// show or hide navbar
export const setFooterVisibility = (newState) => ({
    type: C.FOOTER_SHOW,
    payload: newState
});


// WEBPACK FOOTER //
// ./src/containers/navigation/actions/navbar.js